<template>
    <v-flex xs12 class="audit-container" pa-2>
        <v-card>
            <v-layout row wrap>
                <v-flex xs12 sm3 d-flex class="question">
                    <slot name="question"></slot>
                </v-flex>

                <v-flex xs12 sm9 class="findings">
                    <v-flex xs12>
                        <v-layout row wrap>
                        <v-flex xs12>
                            <slot name="findings"></slot>
                        </v-flex>

                        <v-flex xs12>
                            <slot name="createfinding"></slot>
                        </v-flex>   
                    </v-layout>
                        
                    </v-flex>
                    
                </v-flex>        
            </v-layout>  
        </v-card>
    </v-flex>
</template>

<script>
export default {
  mounted() {
    //console.log("foo", "AUDIT ITEM ROWS MOUNTED");
  }
};
</script>
